import type { RivalryStage } from "../../../shared/types/PlayerMemory";
import type { Language } from "../i18n";

const KO: Record<string, string> = {
  unknown: "미지",
  annoyed: "짜증",
  rival: "숙적",
  obsessed: "집착",
  respectful_enemy: "인정한 적"
};

const EN: Record<string, string> = {
  unknown: "Unknown",
  annoyed: "Annoyed",
  rival: "Rival",
  obsessed: "Obsessed",
  respectful_enemy: "Respected Enemy"
};

/** Localized label for a rivalry stage, shared by the menu badge and the career dashboard. */
export function rivalryStageLabel(stage: RivalryStage | string | undefined, language: Language): string {
  const table = language === "ko" ? KO : EN;
  return table[stage ?? "unknown"] ?? table.unknown ?? "Unknown";
}
